import { render } from "./Sources.vue?vue&type=template&id=318dc783&scoped=true&ts=true"
import script from "./Sources.vue?vue&type=script&lang=ts"
export * from "./Sources.vue?vue&type=script&lang=ts"

import "./Sources.vue?vue&type=style&index=0&id=318dc783&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318dc783"]])

export default __exports__